import { observer } from 'mobx-react';
import { MulticheckStore } from '../Store';
import DeselectAll from './DeselectAll';
import SelectAll from './SelectAll';

interface Props<T> {
  store: MulticheckStore<T>;
}

function MulticheckControls<T>({ store }: Props<T>) {
  switch (store.summaryState) {
    case 'none-checked':
      return (
        <div className="flex">
          <SelectAll store={store} />
        </div>
      );
    case 'all-checked':
      return (
        <div className="flex">
          <DeselectAll store={store} />
        </div>
      );
    case 'some-checked':
      return (
        <div className="flex">
          <DeselectAll store={store} />
          <SelectAll store={store} />
        </div>
      );
  }
}

export default observer(MulticheckControls);
